import React, { useEffect, useState } from 'react'
import { Dictionary } from '@ecountabl/lib'
import api from '../api-client'
import { useDispatch } from 'react-redux'
import notify from '../notifications-helper'
import Spinner from '../spinner'

type ValueRow = {
  _id: string
  slug: string
  label: string
}

type Props = {
  weights: Dictionary<number>
  onChange: (weights: Dictionary<number>) => void
}

const isNonNegativeWeight = (value: number): boolean => {
  return Number.isFinite(value) && value >= 0
}

export const ValueWeightsForm = ({ weights, onChange }: Props): React.ReactElement => {
  const dispatch = useDispatch()
  const [loading, setLoading] = useState(true)
  const [values, setValues] = useState<ValueRow[]>([])

  useEffect(() => {
    api.getValues().then((rows: ValueRow[]) => {
      const sorted = [...(rows || [])].sort((a, b) => {
        return (a.label || '').localeCompare(b.label || '')
      })
      setValues(sorted)
      setLoading(false)
    }).catch((ex: { message?: string }) => {
      dispatch(notify.error({ message: ex.message }))
      setLoading(false)
    })
  }, [])

  if (loading) {
    return <Spinner />
  }

  const onWeightChange = (slug: string, raw: string): void => {
    const next = { ...weights }
    const trimmed = raw.trim()
    if (!trimmed) {
      delete next[slug]
      onChange(next)
      return
    }
    const parsed = Number(trimmed)
    if (!isNonNegativeWeight(parsed)) return
    next[slug] = parsed
    onChange(next)
  }

  return <div className="value-weights">
    <h4>Value match weights</h4>
    <p>
      Each selected value a company matches is worth 10 points when ranking alternatives and explore tag lists.
      This number multiplies that base. Leave a value blank to use 1. Enter 0 if a match should not affect the order.
    </p>
    <div className="list-group">
      {values.map((value) => (
        <div key={value._id} className="list-group-item" style={{ display: 'flex', alignItems: 'center', gap: 12 }}>
          <div style={{ flex: 1 }}>{value.label}</div>
          <input
            type="number"
            min={0}
            step="any"
            className="form-control"
            style={{ maxWidth: 120 }}
            aria-label={`${value.label} weight`}
            value={weights[value.slug] ?? ''}
            onChange={(event) => onWeightChange(value.slug, event.target.value)}
          />
        </div>
      ))}
    </div>
  </div>
}

export default ValueWeightsForm
